module.exports = __webpack_public_path__ + "static/img/duofanghuiyi.2366af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/duofanghuiyi.png
// module id = FeS9
// module chunks = 24